import React from 'react';
import Header from '../../components/Header';
import { useHistory } from "react-router-dom";
import './index.css';

export default function Ferias() {

    let history = useHistory();

    function clickFerias() {
        history.push(`/statusferias`);
    }

    return (
        <div className="container-lg">
            <Header title="FÉRIAS" />
            <input type="button" className="card-orcamento open" value="RELATORIOS" onClick={() => clickFerias()} />
        </div>
    )
}